import { render } from "./TgPayment.vue?vue&type=template&id=67b2ccd3&scoped=true"
import script from "./TgPayment.vue?vue&type=script&lang=js"
export * from "./TgPayment.vue?vue&type=script&lang=js"

import "./TgPayment.vue?vue&type=style&index=0&id=67b2ccd3&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b2ccd3"]])

export default __exports__